export function flattenConceptQuestionSections(sections = []) {
  return sections.flatMap((section) => section.questions ?? []);
}
